
    <app-site-viewer
      [siteId]="data?.key"
      [viewMode]="viewMode">
    </app-site-viewer>
  